import { WaterBoilerAutoIcon } from './WaterBoilerAutoIcon';

/**
 * author: Michael Irigoyen
 * id E7E8E8F3-F414-440D-9CC1-F96CD5533040
 * name water-boiler-auto
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-boiler-auto.svg
 * tags
 * - Home Automation 
 */
export const WaterHeaterAutoIcon = WaterBoilerAutoIcon;
export default WaterHeaterAutoIcon